import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class ScheduledPropertyBody extends Component {
  render() {
    var addressLine = this.props.data.Location.Address1;

    if (this.props.data.Location.Address2) {
      addressLine += ", " + this.props.data.Location.Address2;
    }

    if (this.props.data.Location.Address3) {
      addressLine += ", " + this.props.data.Location.Address3;
    }

    let addressLine2 = "";

    if (this.props.data.Location.City) {
      addressLine2 += ", " + this.props.data.Location.City;
    }

    if (this.props.data.Location.State) {
      if (addressLine2 !== "") {
        addressLine2 += ", ";
      }

      addressLine2 += this.props.data.Location.State;
    }

    if (this.props.data.Location.ZipCode) {
      if (addressLine2 !== "") {
        addressLine2 += " ";
      }

      addressLine2 += this.props.data.Location.ZipCode;
    }

    if (addressLine2 !== "") {
      addressLine = addressLine + addressLine2;
    }

    return (
      <div>
        <div className="data-line">
          <span>Description: </span>
          <span className="value-data">{this.props.data.Description}</span>
        </div>
        <div className="data-line">
          <span>Value: </span>
          <span className="value-data">
            {FormatUtils.formatMoney(this.props.data.Value)}
          </span>
        </div>
        <div className="data-line">
          <span>Location: </span>
          <span className="value-data">{addressLine}</span>
        </div>
      </div>
    );
  }
}

export default ScheduledPropertyBody;
